var InteractiveInviteRedirector = xClass("InteractiveInviteRedirector", BaseRedirector)
InteractiveInviteRedirector.prototype.getName = function () {
    return "interactiveInvite";
}
InteractiveInviteRedirector.prototype.hasHighPriorityAction = function() {
    return false;
}
InteractiveInviteRedirector.prototype.redirect = function () {
    var self = this
    var um = UserManager.getInstance();
    if (!Object.keys(um.settings.data).length) {
        // um还没解析login, 等待下次执行
        return false;
    }
    console.log("interactiveInvite", "InteractiveInviteRedirector run")
    if(SnsProxy.getInstance().allowInteractiveInvite()) {
        window.OpenContextUtil.postMessage({
            command: "interactive redirector",
            openid: META.user.openid,
            time: Localhost.time(), 
            isNew: _G.kIsNewUser? 1: 0
        });
    }

    // TODO:如果按键存在，刷新状态
    return true;
}

module.exports = InteractiveInviteRedirector